//#region redux
import { documentDraftSnoozed } from "store/actions/documentDraftActions";
import { useDispatch } from "react-redux";
//#endregion
//#region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
//#endregion
import useSnoozeAction from "components/common/useSnoozeAction";

function useDocumentDraftSnoozeAction(id: number, markAsDone: (id: number) => void) {
  const dispatch = useDispatch();

  const onSnoozeSuccess = () => {
    dispatch(documentDraftSnoozed(id));
    markAsDone(id);
  };

  const { snoozeAction } = useSnoozeAction(id, WintSuperkollAPIModel.TodoType.DocumentDraft, onSnoozeSuccess);

  return snoozeAction;
}

export default useDocumentDraftSnoozeAction;
